var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-carousel__container"},[_c('img',{attrs:{"src":_vm.images[0].src,"alt":_vm.images[0].alt,"draggable":"false"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }